import { render, staticRenderFns } from "./NewItemModal.vue?vue&type=template&id=09c51f52&"
import script from "./NewItemModal.vue?vue&type=script&lang=js&"
export * from "./NewItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('09c51f52', component.options)
    } else {
      api.reload('09c51f52', component.options)
    }
    module.hot.accept("./NewItemModal.vue?vue&type=template&id=09c51f52&", function () {
      api.rerender('09c51f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Index/NewItemModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/NewItemModal.vue
// module id = bFBr
// module chunks = 0